import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "../Components/ScrollToTop";
import { MainPage } from "../pages/MainPage/MainPage";
import RegistrationMainPage from "../pages/RegistrationPage/RegistrationMainPage";
import NpoLogin from "../pages/NpoLogin/NpoLogin";
import ContactUs from "../pages/ContactUs/ContactUs";
import MainLoginPage from "../pages/LoginPage/MainLoginPage";
import DataUserLoginPage from "../pages/LoginPage/DataUserLoginPage";
import CreateAccountMainPage from "../pages/CreateAccount/CreateAccountMainPage";
import NpoRedirection from "../pages/NpoRedirection/NpoRedirection";
import EditAccountMainPage from "../pages/EditAccount/EditAccountMainPage";
import ProfilePage from "../pages/Profile/ProfilePage";
import NpoSearch from "../pages/NpoSearch/NpoSearch";
import NpoProfile from "../pages/NpoProfile/NpoProfile";
import Loading from "../Components/Loader/Loading";
import { SearchProvider } from "../pages/NpoSearch/Context";
import { useQuery } from "@tanstack/react-query";
import { getUrlList } from "../Store/npoProfile/npoProfile";
import Error404 from "../pages/404/Error404";
import TermOfUse from "../Components/FooterComp/footerSections/TermOfUse";
import Disclaimer from "../Components/FooterComp/footerSections/Disclaimer";
import Copyrights from "../Components/FooterComp/footerSections/Copyrights";
import WorkWithUs from "../Components/FooterComp/footerSections/WorkWithUs";
import Feedback from "../Components/FooterComp/footerSections/Feedback";
import ReportNpo from "../Components/FooterComp/footerSections/ReportNpo";
import Support from "../Components/FooterComp/footerSections/Support";
import PrivacyPolicy from "../Components/FooterComp/footerSections/PrivacyPolicy";
// import { trackPageview } from "../services/analytics";
import StatutoryInformation from "../Components/AboutComp/AboutSection/StatutoryInformation";

const RouteContent = () => {
  const { data: npoCusUrls } = useQuery({
    queryKey: ["getUrlList"],
    queryFn: getUrlList,
    refetchOnWindowFocus: false,
  });

  // Delay rendering routes for 12 seconds (wait for custom urls)
  const [ready, setReady] = React.useState(false);

  // const location = useLocation();

  // useEffect(() => {
  //   trackPageview();
  // }, []);

  // useEffect(() => {
  //   trackPageview(); // Tracks navigation after initial load
  // }, [location.pathname]);

  React.useEffect(() => {
    const timer = setTimeout(() => setReady(true), 12000);
    return () => clearTimeout(timer);
  }, []);

  const loginRoutes = [
    "/loginDataUser",
    "/npo-login",
    "/register-npo",
    "/user-login",
  ];

  return (
    <>
      <ScrollToTop />
      <SearchProvider>
        {/* Wait for npoCusUrls to load or timeout before rendering routes */}
        {npoCusUrls || ready ? (
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<MainLoginPage />} />
            {loginRoutes.map((path) => (
              <Route key={path} path={path} element={<DataUserLoginPage />} />
            ))}
            <Route path="/loginNpo" element={<NpoLogin />} />

            {/* Protected Routes */}
            <Route path="/" element={<MainPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/registration" element={<RegistrationMainPage />} />
            <Route path="/CreateAccount" element={<CreateAccountMainPage />} />
            <Route path="/redirection" element={<NpoRedirection />} />
            <Route path="/editAccount" element={<EditAccountMainPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/search" element={<NpoSearch />} />
            <Route path="/npo-profile/:orgName" element={<NpoProfile />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermOfUse />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/copyright" element={<Copyrights />} />
            <Route path="/careers" element={<WorkWithUs />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/report-npo" element={<ReportNpo />} />
            <Route path="/support" element={<Support />} />
            <Route
              path="/statutory-information"
              element={<StatutoryInformation />}
            />

            {/* Dynamic NPO Custom URL Routes */}
            {npoCusUrls?.documents?.map((urls) => {
              if (!urls?.custom_url) return null;
              let pathname = urls.custom_url;

              try {
                const urlObj = new URL(urls.custom_url);
                pathname = urlObj.pathname;
              } catch (error) {
                pathname = urls.custom_url.startsWith("/")
                  ? urls.custom_url
                  : `/${urls.custom_url}`;
              }

              return (
                <Route
                  key={pathname}
                  path={pathname}
                  element={<NpoProfile />}
                />
              );
            })}

            {/* Other Routes */}
            <Route path="/loader" element={<Loading />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        ) : (
          <Loading />
        )}
      </SearchProvider>
    </>
  );
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <RouteContent />
    </BrowserRouter>
  );
};

export default AppRoutes;
